/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { ErrorsDetailsTypes } from '_core/types';

type InfosTypes = {
  [key: string]: boolean;
};

export const handleCodeErrorsResponse = (
  errors: ErrorsDetailsTypes[],
  definitions: unknown[] | null | undefined,
): InfosTypes => {
  let infos = {};

  definitions?.forEach((element: any) => {
    errors?.map((error: any) => {
      element.CODE_ERRORS.map((err: any) => {
        if (error.entity === element.ENTITY_NAME) {
          const errorCodeStr = error.errorCode?.toString();
          if (err.code === errorCodeStr) {
            infos = {
              ...infos,
              [err.bussinessErrorVariant]: true,
            };
          }
          const currentKey = err.bussinessErrorVariant;
          if (!(currentKey in infos)) {
            infos = {
              ...infos,
              [err.bussinessErrorVariant]: false,
            };
          }
        }
      });
    });
  });

  return infos;
};
